import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  postCustomerInquiries,
  PostCustomerInquiriesParams,
} from '../../../../api/inquiry/mutations/postCustomerInquiries';

type PostCustomerInquiriesOptions = UseMutationOptions<void, Error, PostCustomerInquiriesParams>;
export const usePostCustomerInquiriesMutation = (options?: PostCustomerInquiriesOptions) => {
  return useMutation<void, Error, PostCustomerInquiriesParams>(postCustomerInquiries, { ...options });
};
